import { render } from "./IdentifierSessions.vue?vue&type=template&id=563d612b"
import script from "./IdentifierSessions.vue?vue&type=script&lang=js"
export * from "./IdentifierSessions.vue?vue&type=script&lang=js"

import "./IdentifierSessions.vue?vue&type=style&index=0&id=563d612b&lang=scss"

import exportComponent from "/home/admin/armada-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__